import React from 'react';
import { Button } from '@gravity-ui/uikit';
import { getSearchSiteUrl } from '../../utils';
import { block } from '../../utils/cn';
import i18n from './i18n';
import './AllResultsButton.css';
import { jsx as _jsx } from "react/jsx-runtime";
var b = block('all-results-button');
export function AllResultsButton(_ref) {
  var _customParams$url, _customParams$title;
  var allResultsLinks = _ref.allResultsLinks,
    scope = _ref.scope,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    filter = _ref.filter,
    baseUrl = _ref.baseUrl,
    className = _ref.className,
    buttonRef = _ref.buttonRef,
    onKeyDown = _ref.onKeyDown,
    onClick = _ref.onClick;
  var customParams = allResultsLinks === null || allResultsLinks === void 0 ? void 0 : allResultsLinks[scope];
  return /*#__PURE__*/_jsx("div", {
    onKeyDown: onKeyDown,
    className: b(null, className),
    children: /*#__PURE__*/_jsx(Button, {
      href: (_customParams$url = customParams === null || customParams === void 0 ? void 0 : customParams.url) !== null && _customParams$url !== void 0 ? _customParams$url : getSearchSiteUrl({
        text: text,
        scope: scope,
        filter: filter,
        baseUrl: baseUrl
      }),
      ref: buttonRef,
      onClick: onClick,
      children: (_customParams$title = customParams === null || customParams === void 0 ? void 0 : customParams.title) !== null && _customParams$title !== void 0 ? _customParams$title : i18n('all_results', {
        scope: i18n("of_".concat(scope))
      })
    })
  });
}
// #sourceMappingURL=AllResultsButton.js.map